module.exports = __webpack_public_path__ + "img/banner2.ab2d85c2.png";